"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextBubbleChoiceFull = void 0;
const ChoiceButton_1 = require("../ChoiceButtons/ChoiceButton");
const consts_1 = require("../../consts");
const CommentsBubble_1 = require("./CommentsBubble");
const TextBubbleFullBase_1 = require("./TextBubbleFullBase");
const TextBubbleBase_1 = require("./TextBubbleBase");
const TextBubbleCSS_1 = require("./TextBubbleCSS");
/**
 * Choice TextBubble Controller - with list of options
 */
class TextBubbleChoiceFull extends TextBubbleFullBase_1.TextBubbleFullBase {
    constructor(scene, imagesList, getDevicePixelRatio, stylesAlias, isMultiplayer, textBubbleController) {
        super(scene, imagesList, getDevicePixelRatio, textBubbleController);
        this.buttonsList = [];
        this.buttonsListByAnswerNum = [];
        this.buttonsListByAvatarTexture = {};
        this.isHeartsDisabled = false;
        this.isTraitsHidden = true;
        this._stylesAlias = stylesAlias;
        this._isMultiplayer = isMultiplayer;
        this.gameplayScene = scene;
        this.text = "";
        this.clickCommentsBubble = this.clickCommentsBubble.bind(this);
    }
    init(props) {
        const { text, answers, answerCallback, commentsNum, commentsClickCallback } = props;
        this.text = text;
        this.answers = answers;
        this.answerCallback = answerCallback;
        this.commentsNum = `${commentsNum}`;
        this.commentsClickCallback = commentsClickCallback;
        this.isHeartsDisabled = false;
        this.isTraitsHidden = true;
        this.createTextBubble();
        this.createCommentsBubble();
    }
    uninit() {
        this.destroy();
    }
    destroy() {
        this.destroyAllButtons();
        if (this.textBubble) {
            this.textBubble.destroy();
        }
        if (this.commentsBubble) {
            this.commentsBubble.destroy();
        }
        super.destroy();
    }
    destroyAllButtons() {
        for (const btn of this.buttonsList) {
            btn.destroy();
        }
        this.buttonsList = [];
        this.buttonsListByAnswerNum = [];
        this.buttonsListByAvatarTexture = {};
    }
    updateStylesAlias(stylesAlias) {
        var _a, _b;
        this._stylesAlias = stylesAlias;
        (_a = this.textBubble) === null || _a === void 0 ? void 0 : _a.updateStylesAlias(stylesAlias);
        for (const btn of this.buttonsList) {
            btn.refreshStyle();
        }
        (_b = this.commentsBubble) === null || _b === void 0 ? void 0 : _b.updateStylesAlias(stylesAlias);
    }
    /**
     * Set additional parameters to show choice buttons with corresponding styles
     */
    setAnswersSettings(settings) {
        if (!settings) {
            return;
        }
        this.extraSettings = settings;
        this.isHeartsDisabled = settings.isHeartsDisabled;
        this.isTraitsHidden = settings.isTraitsHidden;
        // disable comments if in multiplayer mode
        if (this._isMultiplayer) {
            this.setIsVisibleComments(false);
        }
        // disable comments if specifed that option
        if (settings.isVisibleComments !== undefined) {
            this.setIsVisibleComments(settings.isVisibleComments);
        }
    }
    setAnswers(answers) {
        if (!answers) {
            return;
        }
        this.answers = answers;
        this.createChoiceButtons();
    }
    setSelectAnswer(answerNum) {
        for (const btn of this.buttonsList) {
            const isButtonSelected = (btn.getAnswerNum() === answerNum);
            btn.setSelectedState(isButtonSelected);
        }
    }
    setDisableButtons() {
        for (const btn of this.buttonsList) {
            btn.disableInteractivity();
        }
    }
    setVotesExtras(votesData) {
        const { winningAnswer, votersAvatarsArr, votesCountsArr } = votesData;
        this.markWinningAnswer(winningAnswer);
        this.updateButtonsWithAvatars(votersAvatarsArr);
        this.updateButtonsVotesCounters(votesCountsArr);
    }
    updateButtonsWithAvatars(answersAvatarsList) {
        answersAvatarsList.forEach((avatarsList, answerNum) => {
            const btn = this.buttonsListByAnswerNum[answerNum];
            for (let avatarUrl of avatarsList) {
                btn.createAvatar(avatarUrl);
            }
        });
    }
    markWinningAnswer(winningAnswerNum) {
        for (const btn of this.buttonsList) {
            if (btn.getAnswerNum() === winningAnswerNum) {
                btn.createSelectedCheckmark();
            }
        }
    }
    updateButtonsVotesCounters(votesCountsArr) {
        votesCountsArr.forEach((votesObj, btnNum) => {
            const btn = this.buttonsListByAnswerNum[btnNum];
            if (btn) {
                btn.createVotesCounter(votesObj.count, votesObj.broadcasterPlayersCount);
            }
        });
    }
    createChoiceButtons() {
        if (!this.answers) {
            return;
        }
        let choiceIndex = 0;
        for (let i = 0; i < this.answers.length; i++) {
            const answer = this.answers[i];
            let tempBtn = new ChoiceButton_1.ChoiceButton(this.gameplayScene, this.getDevicePixelRatio, this, this._isMultiplayer, choiceIndex);
            tempBtn.setIsRawText(this.isRawText);
            tempBtn.setIsVisibleText(this.isVisibleText);
            tempBtn.setExtraSettings(this.extraSettings);
            tempBtn.init(answer, this.answerCallback);
            this.buttonsList[i] = tempBtn;
            this.buttonsListByAnswerNum[answer.num] = tempBtn;
            tempBtn.calcElementsBoundsData();
            if (!answer.isChoiceMemoryDebug && answer.isHidden) {
                continue;
            }
            choiceIndex++;
        }
        this.isRendered = true;
    }
    getButtonByAnswerNum(answerNum) {
        return this.buttonsListByAnswerNum[answerNum];
    }
    createTextBubble() {
        // don't create text bubble if empty string
        if (this.text === '') {
            return;
        }
        this.textBubble = new TextBubbleBase_1.TextBubbleBase(this.gameplayScene, this.imagesList, this.getDevicePixelRatio, this._stylesAlias, this._isMultiplayer, this.textBubbleController);
        this.textBubble.setIsRawText(this.isRawText);
        this.textBubble.setIsVisibleText(this.isVisibleText);
        // this.textBubble.setTextureScale(this.textureScale);
        // this.textBubble.setParentContainerPosition(this.x, this.y);
        this.textBubble.init(this.text, consts_1.SIDE.RIGHT);
    }
    createCommentsBubble() {
        if (!this.isVisibleComments) {
            return;
        }
        this.commentsBubble = new CommentsBubble_1.CommentsBubble(this.gameplayScene, this._stylesAlias, this._isMultiplayer, this.textBubbleController);
        this.commentsBubble.init(this.commentsNum);
        this.commentsBubble.setClickCallback(this.clickCommentsBubble);
    }
    clickCommentsBubble() {
        if (this.commentsClickCallback) {
            this.commentsClickCallback();
        }
    }
    getChoiceButtonCss() {
        return TextBubbleCSS_1.TextBubbleCSS.getChoiceAnswerCSSByAlias(this._stylesAlias);
    }
    /**
     * Get list of boundaries for Choice Buttons
     */
    getChoicesBoundsData() {
        if (!this.buttonsList) {
            return false;
        }
        const boundsDataArr = [];
        for (const btn of this.buttonsList) {
            boundsDataArr.push(btn.getElementBoundsData());
        }
        return boundsDataArr;
    }
    setIsVisibleComments(isVisibleComments) {
        super.setIsVisibleComments(isVisibleComments);
        if (this.commentsBubble && isVisibleComments !== undefined) {
            this.commentsBubble.setCommentsVisible(isVisibleComments);
        }
    }
    updateText(text) {
        if (this.text === text) {
            return;
        }
        this.text = text;
        if (!this.textBubble || !this.textBubble.dialogueElement) {
            return;
        }
        this.textBubble.dialogueElement.mainText = text;
    }
    updateChoiceTexts(texts) {
        for (let i = 0; i < this.buttonsList.length; i++) {
            const btn = this.buttonsList[i];
            btn.updateText(texts[i]);
        }
    }
    updateChoiceAnalytics(analyticStep) {
        this._analyticStep = analyticStep;
        if (!this._analyticStep.answers) {
            return;
        }
        for (let i = 0; i < this.buttonsList.length; i++) {
            const btn = this.buttonsList[i];
            const answerAnalyticStep = this._analyticStep.answers[i];
            if (!answerAnalyticStep) {
                continue;
            }
            btn.displayAnalytics(answerAnalyticStep);
        }
    }
    updateChoiceAnalyticsViewType(viewType) {
        for (let i = 0; i < this.buttonsList.length; i++) {
            const btn = this.buttonsList[i];
            btn.changeViewType(viewType);
        }
    }
    hideChoiceAnalytics() {
        for (let i = 0; i < this.buttonsList.length; i++) {
            const btn = this.buttonsList[i];
            btn.hideAnalytics();
        }
    }
}
exports.TextBubbleChoiceFull = TextBubbleChoiceFull;
